import React from "react";
import cx from "classnames";

import { Tooltip } from "@my-scoot/component-library-legacy";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import style from "../../style.module.css";

const ThemeList = (props) => {
  const { theme, themeSlug, setThemeSlug, disableAllEdits } = props;

  const previewCodes = (
    theme?.codes?.previewColors?.length > 0
      ? theme?.codes?.previewColors
      : Object.keys(theme?.color_codes || {})
  ).map((v) => [v, theme?.color_codes?.[v]]);

  return (
    <div key={theme.slug} className={style.themeItem}>
      <div>{theme.title}</div>
      <div className={cx(style.themeRow, style.disabled)}>
        <div
          className={`${style.paletteContainer} ${
            disableAllEdits && style.disabled
          } ${theme.slug === themeSlug ? style.selectedPaletteContainer : ""}`}
        >
          {previewCodes
            .filter(([, c]) => c)
            .map(([k, c]) => (
              <Tooltip
                key={k}
                title={
                  Array.isArray(theme?.codes?.labels?.[k])
                    ? theme?.codes?.labels?.[k][0]
                    : theme?.codes?.labels?.[k]
                }
                color="primary"
                placement="top"
                arrow
              >
                <div
                  className={style.paletteItem}
                  onClick={() => {
                    if (disableAllEdits) return;
                    setThemeSlug(theme.slug);
                  }}
                  style={{
                    backgroundColor: `rgb(${c})`,
                    borderColor: `rgb(${c})`,
                  }}
                />
              </Tooltip>
            ))}
        </div>
        {theme.slug === themeSlug ? (
          <div className={style.selectedThemeTick}>
            <CheckCircleIcon />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ThemeList;
